import React, { useEffect, useState, useContext } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/database';
import UserContext from '../context/UserContext';
import Breadcrumb from '../components/Breadcrumb';
import '../styles/admin.css';

const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL;
const db = firebase.firestore();

const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;
const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

const StatCard = ({ label, value, sub }) => (
  <div className="adminStatCard">
    <div className="adminStatValue">{value === null ? '...' : value}</div>
    <div className="adminStatLabel">{label}</div>
    {sub && <div className="adminStatSub">{sub}</div>}
  </div>
);

const AdminPage = () => {
  const { user } = useContext(UserContext);
  const isAdmin = user?.email === ADMIN_EMAIL;

  const [activeUsers, setActiveUsers] = useState(null);
  const [totalUsers, setTotalUsers] = useState(null);
  const [newUsers, setNewUsers] = useState(null);
  const [activeCampaigns, setActiveCampaigns] = useState(null);
  const [libraryCount, setLibraryCount] = useState(null);

  useEffect(() => {
    if (!isAdmin) return;

    const thirtyDaysAgo = new Date(Date.now() - THIRTY_DAYS_MS);

    const sevenDaysAgo = new Date(Date.now() - SEVEN_DAYS_MS);

    db.collection('users').get().then(snap => {
      setTotalUsers(snap.size);
      const active = snap.docs.filter(d => {
        const lastSeen = d.data().lastSeen?.toDate?.();
        return lastSeen && lastSeen > thirtyDaysAgo;
      }).length;
      setActiveUsers(active);
      const newU = snap.docs.filter(d => {
        const createdAt = d.data().createdAt?.toDate?.();
        return createdAt && createdAt > sevenDaysAgo;
      }).length;
      setNewUsers(newU);
    });

    const thirtyDaysAgoTs = firebase.firestore.Timestamp.fromDate(new Date(Date.now() - THIRTY_DAYS_MS));
    db.collection('campaigns').where('lastRollAt', '>=', thirtyDaysAgoTs).get().then(snap => {
      setActiveCampaigns(snap.size);
    });

    db.collection('library').get().then(snap => {
      setLibraryCount(snap.size);
    });
  }, [isAdmin]);

  if (!isAdmin) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <p>Accès refusé.</p>
      </div>
    );
  }

  return (
    <div className="adminPage">
      <Breadcrumb current="Admin" />
      <h1 className="adminTitle">Dashboard Admin</h1>
      <div className="adminStatsGrid">
        <StatCard
          label="Utilisateurs actifs"
          value={activeUsers}
          sub={totalUsers !== null ? `sur ${totalUsers} total (30 derniers jours)` : null}
        />
        <StatCard
          label="Nouveaux inscrits"
          value={newUsers}
          sub="7 derniers jours"
        />
        <StatCard
          label="Campagnes actives"
          value={activeCampaigns}
        />
        <StatCard
          label="Éléments bibliothèque"
          value={libraryCount}
        />
      </div>
    </div>
  );
};

export default AdminPage;
